import { Alert, Box } from '@mui/material';
import { CONFIG } from '~/config';

function TopBarAlert() {
  return (
    <Box sx={{ width: '100%', position: 'relative', top: 0, left: 0, zIndex: 0 }}>
      <Alert
        severity="warning"
        variant="filled"
        sx={{
          textAlign: 'center !important',
          borderRadius: 0,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        This product is currently in private preview and is only available to invited users.
        If you would like to be notified when it becomes publicly available, please email us at
        <strong> {CONFIG.app.supportEmail}</strong>.
      </Alert>
    </Box>
  );
}

export default TopBarAlert;
